export default () => ({
    notifications: [],
    unreadNotifications: [],
    total:0,
    pages:0,
    loading:false,
    bellLoading:false,
    config: []
});
  